// extracted by mini-css-extract-plugin
export default {"container":"QQ-z","title":"RQ-z","link":"SQ-z"};